import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import cls from './ProjectTeamRow.module.css';
import { useProjectTeamRow } from './useProjectTeamRow';
import { Icon } from '../../../../../../../components/newUI/Icon/Icon';
import { TeamMembersList } from '../../../UI/TeamMembersList/TeamMembersList';

interface ProjectTeamRowProps {
    classes?: string;
}

export const ProjectTeamRow = ({ classes }: ProjectTeamRowProps) => {
    const { addMemberToTeam, is_customer, can_show_financial_info } = useProjectTeamRow();

    const { t } = useTranslation();

    return (
        <div data-team="team" className={classNames(cls.ProjectTeamRow, [classes])}>
            <span className={cls.title}>{t('ProjectTeamRow.return.title')}</span>
            <div className={cls.TeamRow}>
                <TeamMembersList />
                {!is_customer && can_show_financial_info && (
                    <UiButton
                        className={cls.buttonAdd}
                        onClick={addMemberToTeam}
                        variant="icon"
                        startIcon={<Icon iconName="plus" />}
                    />
                )}
            </div>
        </div>
    );
};
